<template>
<div id="terminos" >
    <div>
        <v-breadcrumbs :items="breadcrumbs" >
            <v-icon slot="divider" >forward</v-icon>
        </v-breadcrumbs>
    </div>
    <v-container fluid fill-height>
        <v-layout align-center justify-center>
            <v-flex xs12>
                <base-material-card color="primary" icon="library_books" title="Administrar Terminos y Condiciones" class="elevation-1 px-5 py-3" >
                    <v-card-text>
                        <v-form ref="form" lazy-validation>
                            <v-container text-xs-center>

                                <v-layout row wrap>
                                    <v-flex s12 m12 l12>
                                        <v-layout row wrap>
                                            <v-flex x12 s6 m6 l6>
                                                <v-text-field label="Breve descripción" type="text" v-model="model.nombre" :rules="[model.rules.required]" maxlength="50" ></v-text-field>
                                            </v-flex>
                                            <v-flex x12 s6 m6 l6 style="text-align:right" >
                                                <v-btn text color="secondary" @click.native="mostrarHistorico" >
                                                    <v-icon>launch</v-icon>Ver historial de términos
                                                </v-btn>
                                            </v-flex>
                                        </v-layout>
                                        <br />
                                        <base-material-card color="primary" title="Términos en Español" class="elevation-1 px-5 py-3" >
                                        <br/>                                            
                                            <ckeditor class="document-editor" :editor="editor" 
                                                    @ready="onReady" v-model="model.content" :rules="[model.rules.required]" :config="editorConfig" ></ckeditor>                                            
                                            <div  style="display:none!important;" >
                                                <div id="editorEspanolOculto" v-html="model.content" ></div>
                                            </div>
                                        </base-material-card>

                                        <base-material-card color="primary" title="Términos en Inglés" class="elevation-1 px-5 py-3" >
                                            <ckeditor class="document-editor" :editor="editor" 
                                                    @ready="onReady" v-model="model.content_ingles" :config="editorConfig" ></ckeditor>
                                            <div style="display:none!important;" >
                                                <div id="editorInglesOculto" v-html="model.content_ingles" ></div>
                                            </div>
                                        </base-material-card>                                        

                                        <br />
                                        <hr />
                                        <v-checkbox v-model="model.resetUsuarios" >
                                            <span slot="label" >Activar esta casilla, si se requiere que TODOS los
                                                usuarios registrados vuelvan a leer y aceptar los
                                                términos.</span>
                                        </v-checkbox>
                                    </v-flex>
                                </v-layout>
                            </v-container>
                        </v-form>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn @click.native="vistaPrevia('español')" >
                            <v-icon>search</v-icon> Vista Previa Español
                        </v-btn>
                        <v-btn @click.native="vistaPrevia('ingles')" >
                            <v-icon>search</v-icon> Vista Previa Inglés
                        </v-btn>
                        <v-btn color="success" :loading="loading" @click.native="terminosPDF('guardar')" >
                            <v-icon>done</v-icon> Guardar
                        </v-btn>
                    </v-card-actions>                    

                    <v-dialog v-model="modal" max-width="80%" scrollable>
                        <v-card>
                            <v-card-title>
                                <v-card class="primary white--text titulomodal" >
                                    <v-icon class="white--text" >search</v-icon>&nbsp;
                                    <span class="subheading" >
                                        <strong>Terminos y Condiciones</strong>
                                    </span>
                                </v-card>
                                <v-spacer></v-spacer>
                                <v-btn icon @click.native="modal = false" class="close_modal" >
                                    <v-icon class="white--text" >cancel</v-icon>
                                </v-btn>
                            </v-card-title>
                            <v-divider></v-divider>
                            <v-card-text>
                                <v-container grid-list-md>
                                    <v-layout wrap>
                                        <v-flex xs12>
                                            <div id="htmleditor" v-html="terminosVistaPrevia" ></div>                                            
                                        </v-flex>
                                    </v-layout>
                                </v-container>
                            </v-card-text>
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn color="blue darken-1" text @click.native="modal = false" >Cerrar</v-btn>
                                <v-btn v-if="false" color="success" @click="terminosPDF()" >
                                    <v-icon class="white--text" >cloud_upload</v-icon>
                                    Descargar PDF
                                </v-btn>                                
                            </v-card-actions>
                        </v-card>
                    </v-dialog>

                    <v-dialog v-model="modalhistorico" max-width="60%" >
                        <v-card>
                            <v-card-title>
                                <v-card class="primary white--text titulomodal" >
                                    <v-icon class="white--text" >library_books</v-icon>&nbsp;
                                    <span class="subheading" >
                                        <strong>Historial de Términos y Condiciones</strong>
                                    </span>
                                </v-card>
                                <v-spacer></v-spacer>
                                <v-btn icon @click.native="modalhistorico = false" class="close_modal" >
                                    <v-icon class="white--text" >cancel</v-icon>
                                </v-btn>
                            </v-card-title>

                            <v-card-text>
                                <v-client-table ref="vuetableTerminos" :data="terminos.items" :columns="terminos.columns" :options="terminos.options" class="elevation-2 pa-2" >
                                    <template slot="noResults" >
                                        <v-alert :value="true" icon="info" color="info" >No se encontro ningun registro</v-alert>
                                    </template>
                                    <template slot="options" slot-scope="props" style="text-align:center;" >
                                        
                                    <v-btn icon color="primary" small outlined title="Vista Previa" @click.native="verTerminos(props.row.id_termino,'espanol')" >
                                            <v-icon>visibility</v-icon></v-btn>&nbsp;
                                    <v-btn v-if="props.row.contenido_ingles!=null" icon color="info" small outlined title="Vista Previa Inglés" @click.native="verTerminos(props.row.id_termino,'ingles')" >
                                            <v-icon>visibility</v-icon></v-btn>&nbsp;
                                        <v-btn icon color="primary" small outlined title="Historial de Usuarios" @click.native="
                                            verHistorialUsuarios(props.row.id_termino,props.row.nombre)" >
                                            <v-icon>how_to_reg</v-icon>
                                        </v-btn>
                                            
                                        
                                    </template>

                                </v-client-table>                                
                            </v-card-text>

                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn color="blue darken-1" text @click.native="modalhistorico = false" >Cerrar</v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-dialog>

                    <v-dialog v-model="modalUsuarios" max-width="60%" >
                        <v-card>
                            <v-card-title>
                                <v-card class="primary white--text titulomodal" >
                                    <v-icon class="white--text" >library_books</v-icon>&nbsp;
                                    <span class="subheading" >
                                        <strong>Usuarios que aceptaron los Términos y Condiciones:
                                    {{ descripcionTerminos }}</strong>
                                    </span>
                                </v-card>                                
                            </v-card-title>
                            <v-divider></v-divider>                            
                            <v-card-text>
                                <v-app-bar flat color="white" >                                    
                                    <v-spacer></v-spacer>
                                    <exportar-excel :data="datafiltered" :exportFields="usuarios.camposexcel" name="Usuarios.xlsx" >
                                        <v-btn fab dark x-small color="success" title="Exportar a Excel" v-tippy>
                                            <v-icon dark>get_app</v-icon>
                                        </v-btn>
                                    </exportar-excel>
                                </v-app-bar>                                

                                <v-client-table ref="vuetable" :data="usuarios.items" :columns="columns" :options="options" class="elevation-2 pa-2" >
                                    <template slot="noResults" >
                                        <v-alert :value="true" icon="info" color="info" >No se encontro ningun registro</v-alert>
                                    </template>

                                </v-client-table>

                            </v-card-text>

                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn color="blue darken-1" text @click.native="modalUsuarios = false" >Cerrar</v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-dialog>
                </base-material-card>
            </v-flex>
        </v-layout>
    </v-container>
</div>
</template>

<script>
import Vue from "vue";

import DecoupledEditor from "@ckeditor/ckeditor5-build-decoupled-document";

import axios from "axios";
import moment from "moment";
import html2pdf from "html2pdf.js";

Vue.filter("formatDate", function (value) {
    if (value) {
        return moment(String(value)).format("YYYY-MM-DD");
    }
});

export default {
    components: {},
    data: () => ({
        show_loading: true,
        file: '',
        file_ingles: '',
        breadcrumbs: [{
                text: "Administración",
                disabled: false,
                href: "/admin"
            },
            {
                text: "Terminos y Coindiciones",
                disabled: true,
                href: ""
            }
        ],
        editor: DecoupledEditor,        
        editorConfig: {
            toolbar: [
                "heading",
                "|",
                "fontSize",
                "FontFamily",
                "|", ,
                "bold",
                "italic",
                "underline",
                "Highlight",
                "|",
                "alignment",
                "NumberedList",
                "BulletedList",
                "|",
                "link",
                "blockQuote",
                "|",
                "undo",
                "redo"
            ]
        },
        title: "",
        descripcionTerminos: "",
        modal: false,
        modalhistorico: false,
        modalUsuarios: false,
        loading: false,
        terminosVistaPrevia: "",        
        model: {
            content: "",
            content_ingles: "",
            nombre: "",
            resetUsuarios: false,
            rules: {
                required: v => !!v || "Este campo es requerido"
            }
        },
        searchhistorico: "",
        searchusuarios: "",
        terminos: {
            columns: ["nombre", "fecha", "options"],
            options: {
                filterable: ["nombre", "fecha"],
                sortable: ["nombre", "fecha"],

                headings: {
                    "nombre": "Descripción",
                    "fecha": "Fecha",
                    "options": "Opciones",
                },
            },
            items: []
        },
        pagination: {
            descending: true,
            sortBy: "fecha" //Orden por default
        },
        columns: ["usuario.nombre", "usuario.apellidos", "clientes_texto", "fecha_formato"],
        options: {
            filterable: ["usuario.nombre", "usuario.apellidos", "clientes_texto", "fecha_formato"],
            sortable: ["usuario.nombre", "usuario.apellidos", "clientes_texto", "fecha_formato"],

            headings: {
                "usuario.nombre": "Nombre",
                "usuario.apellidos": "Apellidos",
                "clientes_texto": "Organizaciones",
                "fecha_formato": "Fecha",
            },
        },
        usuarios: {
            camposexcel: {
                "Nombre": "usuario.nombre",
                "Apellidos": "usuario.apellidos",
                "Clientes": "clientes_texto",
                Fecha: "fecha_formato"
            },
            items: []
        }
    }),
    computed: {
        datafiltered() {
            if (this.$refs.vuetable != null) {                                
                return this.$refs.vuetable.allFilteredData;
            } else {                
                return this.usuarios.items;
            }

        },
    },
    methods: {
        onReady(editor) {
            // Insert the toolbar before the editable area.
            editor.ui.view.editable.element.parentElement.insertBefore(
                editor.ui.view.toolbar.element,
                editor.ui.view.editable.element
            );
        },
        getClientesTexto: function (clientes) {
            if (clientes) {
                var clientes_texto = "";
                for (var k in clientes)
                    clientes_texto += clientes[k].rfc + ", ";
                return clientes_texto.substr(0, clientes_texto.length - 2);
            } else
                return '';
        },
        
        terminosPDF: function (opcion = 'descargar') {            
            var opt = {
                margin: [1, 0.5, 1, 0.5], //top, left, bottom, right
                filename: "terminos.pdf",
                image: {
                    type: "jpeg",
                    quality: 0.5
                },
                html2canvas: {
                    scale: 2
                },
                pagebreak: {
                    mode: ["avoid-all", "css", "legacy"]
                },
                jsPDF: {
                    unit: "in",
                    format: "letter",
                    orientation: "portrait",      
                    compress: true,                                 
                }
            };

            if (opcion == 'descargar') {
                var html = document.getElementById("htmleditor");                  
                html2pdf()
                    .set(opt)                    
                    .from(html)                    
                    .save();                
            } else {
                if (!this.$refs.form.validate() || this.model.content.length <= 13) {                    
                    this.$swal({
                        position: "center",
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: 'Formulario incompleto. Favor de verificar.'                        
                    });
                } else {                    
                    var html = document.getElementById("editorEspanolOculto");  
                    this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
                    var thisObj = this;
                    html2pdf()
                        .set(opt)
                        .from(html)
                        .output('datauristring')
                        .then(function (pdf) {

                            thisObj.file = pdf;
                            var html_ingles = document.getElementById("editorInglesOculto");
                            html2pdf()
                                .set(opt)
                                .from(html_ingles)
                                .output('datauristring')
                                .then(function (pdf2) {
                                    thisObj.file_ingles = pdf2;                                
                                    thisObj.registrar();
                                });

                        });
                }
            }

        },
        registrar() {
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            var fecha = moment(new Date()).format("YYYYMMDD");
            const axiosConfig = {
                nombre: this.model.nombre,
                contenido: this.model.content,
                contenido_ingles: this.model.content_ingles,
                fecha: moment(new Date()).format("YYYY-MM-DD"),                
                file: this.file,
                file_ingles: this.file_ingles,
            };
           
            axios.post(this.$hostname + "terminos/guardar/", axiosConfig)
                .then(res => {
                    if (this.model.resetUsuarios == true)
                        this.actualizarTerminosUsuarios();
                    else {
                        this.$swal({
                            type: "success",
                            title: "¡Operación Exitosa!",
                            text: "Se guardó correctamente",
                            footer: ""
                        });
                    }
                })
                .catch(error => {
                    var msg = "";
                    if (error.response != null) {
                        if (error.response.data.mensaje) {
                            msg = error.response.data.mensaje;
                        } else {
                            if (error.response.data.contenido)
                                msg += "Debe agregar contenido a los Términos y Condiciones";
                        }
                    } else {
                        msg = error;
                    }

                    this.$swal({
                        position: "center",
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: msg
                        //showConfirmButton: false,
                    });
                }).then(() => {
                    this.$root.$dialogLoader.hide();
                });
            
        },

        actualizarTerminosUsuarios: function (type) {
            axios
                .put(this.$hostname + "usuarios/update_terminos_usuarios/")
                .then(res => {
                    if (typeof res.data.mensaje !== "undefined")
                        this.$swal({
                            type: "success",
                            title: "¡Operación Exitosa!",
                            text: "Se guardó correctamente",
                            footer: ""
                        });
                    else {
                        this.$swal({
                            type: "warning",
                            title: "Aviso",
                            text: "No se han configurado Términos y Condiciones.",
                            footer: ""
                        });
                    }
                })
                .catch(err => {
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "Ocurrió un error al actualizar campo acepto_terminos de Usuarios.",
                        footer: ""
                    });
                    console.log(err);
                });
        },

        cargarTerminos: function (type) {
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            axios
                .get(this.$hostname + "terminos/get_ultimo/")
                .then(res => {
                    if (typeof res.data[0] !== "undefined") {
                        this.model.content = res.data[0].contenido;
                        this.model.content_ingles = res.data[0].contenido_ingles;
                        this.$root.$dialogLoader.hide();
                    } else {
                        this.$swal({
                            type: "warning",
                            title: "Aviso",
                            text: "No se han configurado Términos y Condiciones.",
                            footer: ""
                        });
                        this.model.content = "Agregar aquí Términos y Condiciones";
                        this.model.content_ingles = "Add here Website terms and conditions of use";
                        this.$root.$dialogLoader.hide();
                    }
                })
                .catch(err => {
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "Ocurrió un error al obtener los Términos y Condiciones.",
                        footer: ""
                    });
                    console.log(err);
                    this.$root.$dialogLoader.hide();
                });
        },        

        vistaPrevia: function (opcion="español") {
            if (opcion=="español"){
                this.terminosVistaPrevia = this.model.content;
            } else {
                this.terminosVistaPrevia = this.model.content_ingles;
            }
            
            this.title = "Términos y Condiciones";
            this.modal = true;
        },

        mostrarHistorico: function () {
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            axios
                .get(this.$hostname + "terminos/")
                .then(response => {
                    this.terminos.items = response.data;
                    this.modalhistorico = true;
                })
                .catch(error => {
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "Ocurrió un error al obtener el histórico.",
                        footer: ""
                    });
                }).then(() => {
                    this.$root.$dialogLoader.hide();
                });
        },

        verTerminos: function (id_termino, opcion="espanol") {            
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            axios.get(this.$hostname + "terminos/" + id_termino + "/")
                .then(response => {                    
                    if (opcion == "espanol")
                        this.terminosVistaPrevia = response.data.contenido;                    
                    else 
                        this.terminosVistaPrevia = response.data.contenido_ingles;
                    this.title = "Términos y Condiciones";
                    this.modal = true;
                })
                .catch(error => {
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "Ocurrió un error al obtener los términos.",
                        footer: ""
                    });
                }).then(()=>{
                    this.$root.$dialogLoader.hide();
                });
        },        
        verHistorialUsuarios: function (id_termino, descripcionTerminos) {
            this.descripcionTerminos = descripcionTerminos;
            var datos = {
                terminos: id_termino
            };
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            axios
                .post(this.$hostname + "terminos/get_aceptados/", datos)
                .then(response => {
                    this.usuarios.items = response.data;
                    for (var k in this.usuarios.items) {
                        this.usuarios.items[k].clientes_texto = this.getClientesTexto(this.usuarios.items[k].clientes);
                        this.usuarios.items[k].fecha_formato = moment(String(this.usuarios.items[k].fecha)).format("YYYY-MM-DD");
                    }
                    this.modalUsuarios = true;
                })
                .catch(error => {
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "Ocurrió un error al obtener los usuarios.",
                        footer: ""
                    });
                    console.log(error);
                }).then(() => {
                    this.$root.$dialogLoader.hide();
                });
        }
    }, //methods
    created: function () {
        this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
        this.cargarTerminos();
    }
};
</script>
<style>
#htmleditor, #editorEspanolOculto, #editorInglesOculto{
    margin-left: 20px;
    height: auto;
    width: auto;
    font-family: Arial, sans-serif;    
}
.document-editor {
    margin-left: 20px;
    height: auto;
    width: auto;
    font-family: Arial, sans-serif;    

    border: 1px solid;

    /* Set vertical boundaries for the document editor. */
    min-height: 250px;
    max-height: 400px;

    /* This element is a flex container for easier rendering. */
    display: flex;
    flex-flow: column nowrap;
}
</style>
